<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'抢单模块'},{title:'线索管理统计表'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <!-- 搜素条件 -->
      <div class="h-piece">
        <div class="h-formBox">
          <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
            <div class="h-thirdColumn w-newColumn">
              <el-form-item label="年度">
                <el-select filterable v-model="q.year" clearable placeholder="请选择">
                  <el-option
                      v-for="(item) in qyearList"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="月度" class="h-elformWrap-2" prop="username">
                <el-select filterable v-model="q.month" clearable placeholder="请选择">
                  <el-option
                      v-for="(item) in monthList"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="大区" prop="areaName">
                <brselect category="daqu" :v="q.daqu" v-model="q.daqu"
                          :clearable="true"
                          style="width:100%"/>
              </el-form-item>
              <el-form-item label="区域" prop="link">
                <el-select v-model="q.areaName" clearable placeholder="请选择" style="width:100%">
                  <el-option v-for="item in quyuList"
                             :key="item.code"
                             :label="item.name"
                             :value="item.name">
                  </el-option>
                </el-select>

              </el-form-item>
            </div>
            <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
              <!--<el-form-item label="领域">-->
              <!--  <el-select filterable v-model="q.field" clearable placeholder="请选择">-->
              <!--    <el-option label="医疗创新" value="1"></el-option>-->
              <!--    <el-option label="生命科学" value="2"></el-option>-->
              <!--  </el-select>-->
              <!--</el-form-item>-->
              <el-form-item label="创建日期" class="timeselect" style="width: 50%;">
                <el-date-picker
                    placeholder="请选择"
                    v-model="q.startDate"
                    clearable
                    type="date"
                    value-format="yyyy-MM-dd" >
                </el-date-picker>
                <span class="w-time-to">至</span>
                <el-date-picker
                    placeholder="请选择"
                    v-model="q.endDate"
                    clearable
                    type="date"
                    value-format="yyyy-MM-dd" >
                </el-date-picker>
              </el-form-item>
            </div>
            </div>
            </el-collapse-transition>
          </el-form>
          <div class="l-screenBox">
            <div class="l-screen" @click="collapseChange">
              <img :src="isScreen?closeScreen:drawScreen" alt="">
              <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
            </div>
            <div class="l-retrieval">
              <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
              <el-button class="h-btn h-formBtn h-bgwhite" @click="rest()">重置</el-button>
            </div>
          </div>
        </div>
      </div>
      <!-- 结果展示 -->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <!-- @selection-change="handleSelectionChange" -->
        <el-table
            ref="multipleTable"
            :data="tableData"
            :border="true"
            max-height="560"
            style="width: 100%"
            fit
            show-summary
            :summary-method="getSummaries"
            :span-method="arraySpanMethod"
        >
          <el-row>
              <el-table-column label="序号" type="index" fixed="left" width="55px"></el-table-column>
              <el-table-column prop="year" label="年度" width="75" ></el-table-column>
              <el-table-column prop="month" label="月度" width="75"></el-table-column>
              <el-table-column prop="daqu" label="大区" width="85"></el-table-column>
              <el-table-column prop="areaName" label="区域" width="85"></el-table-column>
              <el-table-column prop="channelCode" label="渠道" width="85">
                <template scope="scope">
                  <dictname category="clue_channel" :v="scope.row.channelCode"></dictname>
                </template>
              </el-table-column>
              <el-table-column prop="total" sortable label="线索条数" ></el-table-column>
              <el-table-column prop="state" sortable label="闭环数"></el-table-column>
              <el-table-column prop="closerate" sortable label="闭环率"></el-table-column>
              <el-table-column prop="loudAndfollow" sortable label="漏斗/已反馈数" width="200" ></el-table-column>
              <el-table-column prop="totalPrice" sortable label="漏斗/已反馈金额(万元)" width="220" ></el-table-column>
              <el-table-column prop="closeloudrate" sortable label="漏斗录入率"></el-table-column>
          </el-row>
        </el-table>
      </div>
    </div>

    <div class="h-tableB h-mrt30">
      <div class="h-tableBL" style="margin-left: 23px">
        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                   @click="exportExcel">批量导出
        </el-button>
      </div>
      <div class="h-pagination2">
        <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
      </div>
    </div>

  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';
import moment from "moment";

export default {
  data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        year: new Date().getFullYear(),
        month: '',
        daqu: '',
        areaName: '',
        startDate:'',
        endDate:'',
        field:'',
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      size: '',
      tableData: [
        {
          year: '',
          month: '',
          areaName: '',
          total: 0,
          acctotal: 0,
          enterLoud: 0,
          totalPrice: 0,
          followUp: 0,
          nothing: 0,
          invalidMsg: 0,
        }
      ],
      add: {
        year: '',
        month: '',
        daqu: '',
        areaName: '',
        field: '',
        total: 0,
        acctotal: 0,
        enterLoud: 0,
        totalPrice: 0,
        followUp: 0,
        nothing: 0,
        invalidMsg: 0
      },
      qyearList: [],
      monthList: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      quyuList: [],
      sum: {
        sumtotal: 0,
        sumacctotal:0,
        sumcloserate:0,
        sumcloseloudrate:0,
        sumenterLoud: 0,
        totprice: 0.00,
        sumloudAndfollow: 0,
        sumfollowUp: 0,
        sumnothing: 0,
        suminvalidMsg: 0,
      }
    }
  },
  methods: {
    //明细导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/guanhuai/bscClueManage/downloadExcel", this.q, "post", 'data');
    },

    groupListMe() {
      var data = this.add.customerName
      ss.MuBiao.getUser(data).then(res => {
        this.groupList = []
        this.groupArr = []
        this.groupList = res.msg
        for (let item of this.groupList) {
          this.groupArr.push({
            value: item.userName,
            id: item.userCode
          })
        }
      })
    },

    getQuyuList() {
      ss.Dictservice.listbycategory("show_area").then(rd => {
        this.quyuList = rd;
      })
    },

    query() {
      this.selectPageAll()
    },

    selectPageAll() {
      ss.BscClueManage.getBscClueReport(this.q).then(res => {
        this.tableData = res.records;
        this.sum.sumtotal = res.records[0].sumtotal;
        this.sum.sumacctotal = res.records[0].sumacctotal;
        this.sum.sumenterLoud = res.records[0].sumenterLoud;
        this.sum.totprice = res.records[0].totprice;
        this.sum.sumfollowUp = res.records[0].sumfollowUp;
        this.sum.sumnothing = res.records[0].sumnothing;
        this.sum.suminvalidMsg = res.records[0].suminvalidMsg;
        this.sum.sumcloserate = res.records[0].sumcloserate;
        this.sum.sumcloseloudrate = res.records[0].sumcloseloudrate;
        this.sum.sumloudAndfollow = res.records[0].sumloudAndfollow;
        this.q.total = res.total;
      })
    },
    querySearchGroup(queryString, cb) {
      var groupArr = this.groupArr;
      cb(groupArr);
    },
    selectGroup(val) {
      this.add.customerName = val.value
    },

    querySearchGroup1(queryString, cb) {
      var groupArr = this.groupArr;
      cb(groupArr);
    },

    getSummaries(param) {
      //此处打印param可以看到有两项，一项是columns，一项是data，最后一列可以通过columns.length获取到。
      const {columns, data} = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0){
          sums[index] = data.length + 1;
        }else if ( index === 1 || index === 2 ||index === 3 || index === 4 ||index === 5 ) {
          sums[index] = '合计'
        } else if (index >= 6) {
          if (index === 6){
            sums[index] =  this.sum.sumtotal;
          }else if (index === 7){
            sums[index] = this.sum.sumacctotal;
          } else if (index === 8) {
            sums[index] = this.sum.sumcloserate;
          }else if (index === 9) {
            sums[index] = this.sum.sumloudAndfollow;
          }else if (index === 10) {
            sums[index] = this.sum.totprice;
          }else if (index === 11) {
            sums[index] = this.sum.sumcloseloudrate;
          }
        }
      })
      return sums
    },
    arraySpanMethod() {
      this.$nextTick(() =>{
        if(this.$refs.multipleTable.$el){
          var current = this.$refs.multipleTable.$el
              .querySelector(".el-table__footer-wrapper")
              .querySelector(".el-table__footer");
          var cell = current.rows[0].cells;
          cell[0].style.display = "none";
          cell[1].style.display = "none";
          cell[2].style.display = "none";
          cell[3].style.display = "none";
          cell[4].style.display = "none";
          cell[5].classList.remove('is-left');
          cell[5].colSpan = "6";
        }
      })
    },

    handleFilter() {
      this.query();
    },

    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },

    rest() {
      this.q.year = '',
      this.q.month = '',
      this.q.daqu = '',
      this.q.areaName = ''
      this.q.field = '',
      this.q.startDate = '',
      this.q.endDate = ''
    },

    mounted() {
      this.selectPageAll();
    },

  },
  created() {
    this.handleFilter();
    this.getQuyuList();

    for (var i = 2022; i < new Date().getFullYear() + 3; i++) {
      this.qyearList.push(i);
    }
  }

}
</script>
